// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfWeek as fn } from "../endOfWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfWeekWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default endOfWeekWithOptions;
